import Label from './Label'

export default Label



// WEBPACK FOOTER //
// ./src/components/Label/index.js